import React from "react";
import { compose, withAppContext } from "containers/HOC";
import { usePortalModal } from "common/effects";
import ActionLink from "components/ActionLink";
import CreateFarmModal from "./CreateFarmModal";

const CreateFarmLink = ({ online, id, className }) => {
    const { openModal, getModal } = usePortalModal();
    const createFarm = () => {
        openModal("CreateFarmModal");
    };
    const createFarmModal = getModal("CreateFarmModal", CreateFarmModal);

    return (
        <>
            {online && (
                <ActionLink id={id} className={`IconLink--arrow-plus ${className}`} onClick={createFarm}>
                    Create new farm
                </ActionLink>
            )}
            {createFarmModal}
        </>
    );
};

export default compose(withAppContext)(CreateFarmLink);
